import { ModuleList } from '../../../shared/analytics/module-list';
import { pagesConfig } from '../../../shared/pages-config';

export const HELPFUL_INFORMATION_BREADCRUMBS = [
  { label: ModuleList.modules.insights.name },
  {
    label: pagesConfig.insightsHelpfulInformation.name,
    path: `${pagesConfig.insights.link}/${pagesConfig.insightsHelpfulInformation.link}`,
  },
];
